import { component } from 'picoapp'
import '@/lib/jquery-global.js';

export default component((node, ctx) => {
 
    var h = $('.js-form-container').height();
    $('.js-form-container').css('min-height', h);

})
